export const palette = {
  alternate: {
    main: '#F0F7FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#53A5EF',
    contrastText: '#FFF',
    light: '#53A5EF1a',
  },
  secondary: {
    main: '#DEEFFF',
    contrastText: '#144B7D',
  },
  text: {
    primary: '#1E293B',
    secondary: '#5A6D8E',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#E5E5E5',
    paper: '#FFF',
    dark: '#091723',
    default: '#FFF',
    footer: '#0D0C0C',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#144B7D',
    tableSubhead: '#144B7D1a',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    tableBackground: '#DEEFFF59',
    checkIcon: '#37B6AB',
    cancelIcon: '#797979',
  },
  verticalBar: {
    used: '#53A5EF',
    unused: '#bddcf8',
    unlimited: '#C0C0C0',
  }
};
